import {
  ICreateAndUpdateMunicipality,
  ICreateAndUpdateUser,
} from "../../../types/common.interface";
import { ICreateAndUpdateSuperAgent } from "../../../types/superAgent.interface";
import customAxios from "../../customAxios";
import {
  CREATE_ADMIN,
  MUNICYPULITY_UPDATE,
  UPDATE_ADMIN,
  UPDATE_SUPER_AGENT,
} from "../../routes";

const updateAdmin = async (formData: ICreateAndUpdateUser) => {
  try {
    return (
      await customAxios.put(UPDATE_ADMIN + `/${formData._id}`, {
        phoneNumber: formData.phoneNumber,
        firstName: formData.firstName,
        lastName: formData.lastName,
        permission: formData.permission,
      })
    ).data;
  } catch (error: unknown) {
    console.error({ UPDATE_ADMIN: error });
    return false;
  }
};

export default updateAdmin;
